import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  formControl: {
    '& .MuiInputBase-root': {
      marginBottom: theme.spacing(1),
    }
  },
  seePasswordIcon: {
    color: 'rgba(0, 0, 0, 0.54)'
  },
  infoIcon: {
    color: theme.palette.text.secondary,
    height: '20px',
    marginLeft: '6px',
    width: '20px',
    '&.disabled': {
      color: 'rgba(0, 0, 0, 0.38)'
    }
  },
  alert: {
    backgroundColor: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #6BC9A0',
    border: '1px solid rgba(107, 201, 160, 0.5)',
    marginTop: theme.spacing(1),
  },
  tooltip: {
    margin: theme.spacing(0.5, 0, 0, 1.5),
    backgroundColor: 'rgba(97,97,97,0.9)',
    fontSize: '14px',
    lineHeight: '16px',
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.spacing(0.5),
    width: 'fit-content',
    color: theme.palette.common.white,
  },
  font16: {
    fontSize: '16px',
  },
  font14: {
    fontSize: '14px'
  },
  spacer: {
    marginTop: theme.spacing(1),
  }
}));
